import React, { useCallback, Fragment, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Templates from './Templates';
import './Department.scss';
import { stringifyEqualityCheck } from './../../utils';
import * as actions from './Department.actions';
import * as selectors from './Department.selectors';
import * as loginSelectors from './../Login/Login.selectors';
import * as loginActions from './../Login/Login.actions';
import Layout from './../Layout';
import { Helmet } from 'react-helmet';

const Department = (props) => {
    /* State to props */
    const products = useSelector(selectors.getProducts, stringifyEqualityCheck);
    const department = useSelector(selectors.getDepartment, stringifyEqualityCheck);
    const fetching = useSelector(selectors.getFetching);
    const productType = useSelector(selectors.getProductType);
    const user = useSelector(loginSelectors.getUser, stringifyEqualityCheck);

    /* Dispatch to props */
    const dispatch = useDispatch();
    const fetchStaticTemplates = useCallback((id) => dispatch(actions.fetchStaticTemplates(id)), [dispatch]);
    const fetchApparelItems = useCallback((id) => dispatch(actions.fetchApparelItems(id)), [dispatch]);
    const fetchPromotionalItems = useCallback((id) => dispatch(actions.fetchPromotionalItems(id)), [dispatch]);
    const fetchBrochures = useCallback((id) => dispatch(actions.fetchBrochures(id)), [dispatch]);
    const fetchDepartment = useCallback((id) => dispatch(actions.fetchDepartment(id)), [dispatch]);
    const resetState = useCallback(() => dispatch(actions.resetState()), [dispatch]);
    const logout = useCallback((history) => dispatch(loginActions.logout(history)), [dispatch]);

    /* componentDidMount */
    useEffect(() => {
        if (parseInt(props.match.params.productId) === 5 || parseInt(props.match.params.productId) === 6) {
            fetchStaticTemplates(props.match.params.id);
        } else if (parseInt(props.match.params.productId) === 8) {
            fetchPromotionalItems(props.match.params.id);
        } else if (parseInt(props.match.params.productId) === 16) {
            fetchBrochures(props.match.params.id);
        } else {
            fetchApparelItems(props.match.params.id);
        }

        fetchDepartment(props.match.params.id);
        return () => {
            resetState();
        };
    }, [fetchStaticTemplates, fetchApparelItems, fetchDepartment, fetchPromotionalItems, fetchBrochures, 
        resetState, props.match.params.id, props.match.params.productId]);

    if (user == null) {
        logout(props.history);
        return null;
    }

    let title = department != null ? department.name : '';
    if (user != null && department != null && parseInt(department.id) === 412) {
        title = 'Marketing Collateral';
    }

    return (
        <Layout
            title={<Fragment><i className="fas fa-id-card" /> Select Product</Fragment>}
            step={2}
            history={props.history}
        >
            <Helmet>
                <title>Products - UT Physicians</title>
            </Helmet>
            <div className="department-container">
                <h2>{title} Products</h2>
                <h3>Select a product to start your design.</h3>
                <Templates
                    user={user}
                    products={products}
                    fetching={fetching}
                    productType={productType}
                    department={department}
                    id={props.match.params.id}
                    productId={props.match.params.productId}
                />
            </div>
        </Layout>
    );
};

export default Department;
